(function () {
    'use strict';

    angular
        .module('app.lostAndFound')
        .controller('LostAndFoundListController', LostAndFoundListController);

    LostAndFoundListController.$inject = ['$scope', 'common', 'dataservice', 'config', 'carousel.dialog'];
    /* @ngInject */
    function LostAndFoundListController($scope, common, dataservice, config, carouselDialog) {
        var vm = this;
        vm.title = "Lost and Found"
        vm.filteredItems = [];
        vm.items = [];
        vm.refresh = refresh;
        vm.showImage = showImage;
        vm.isLicenseValid = false;
        vm.isLoading = true;
        vm.claimedDto = {};
        vm.openClaimId = '';
        vm.updateClaim = updateClaim;
        vm.closeClaim = closeClaim;
        vm.updateClaim = updateClaim;
        vm.openClaim = openClaim;
        vm.filter = filter;
        vm.itemsFilter = itemsFilter;
        vm.searchText = '';
        vm.displayedItems = [];
        vm.clearFilter = clearFilter;
        vm.claimedButtonText = "Show Claimed";
        vm.showClaimed = false;
        vm.toggleClaimed = toggleClaimed;

        var applyFilter = function () { }
        

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItems(), getLicenseInfo()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
            }, function (error) { });
        }

        function filter($event) {
            if ($event.keyCode === config.keyCodes.esc) {
                vm.searchText = ''
                applyFilter(true);
            }
            else {
                applyFilter();
            }
        }

        function toggleClaimed() {
            if (vm.showClaimed) {
                vm.showClaimed = false;
                vm.claimedButtonText = "Show Claimed";
            }
            else {
                vm.showClaimed = true;
                vm.claimedButtonText = "Show Unclaimed";
            }

            getItems();

        }

        function clearFilter() {
            vm.searchText = '';
            applyFilter(true);
        }

        $scope.$watch('vm.filteredItems', function (val) {
            vm.displayedItems = _chunk(val, 4);
        }, true); 

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                vm.isLicenseValid = true;
                return vm.licenseInfo;
            }, function (error) { });
        }


        function getItems() {
            return dataservice.getItems('api/LostAndFound?showClaimed=' + vm.showClaimed).then(function (response) {
                var data = response.data;
                vm.items = data;
                applyFilter = common.createSearchThrottle(vm, 'items');
                applyFilter(true);
                vm.displayedItems = _chunk(vm.filteredItems, 4);
                return vm.items;
            }, function (error) { });
        }

        function updateClaim() {
            if (vm.claimedDto.claimedByName) {
                dataservice.saveItem('api/LostAndFound/UpdateClaim', vm.claimedDto).then(function (saveResult) {
                    
                    for (var i = 0; i < vm.items.length; i++) {
                        if (vm.items[i].UId == vm.claimedDto.UId) {
                            vm.items.splice(i, 1);
                            applyFilter(true);
                            break;
                        }
                    }
                    vm.claimedDto = {};
                }).catch(function (error) { });

                vm.openClaimId = '';
            }
        }

        function closeClaim() {
            vm.claimedDto = {};
            vm.openClaimId = '';
        }

        function openClaim(uid) {
            vm.claimedDto = {};
            vm.claimedDto.UId = uid;
            vm.openClaimId = uid;
        }


        function _chunk(arr, size) {
            var newArr = [];
            for (var i = 0; i < arr.length; i += size) {
                newArr.push(arr.slice(i, i + size));
            }
            return newArr;
        }

        function refresh() {
            getItems();
        }

        function showImage(item) {
            return carouselDialog.display(item);
        }

        function itemsFilter(item) {
            var textContains = common.textContains;
            var searchText = vm.searchText;
            var isMatch = searchText
                ? (
                    textContains(item.FileName, searchText)
                    || textContains(item.AltText, searchText)
                    || textContains(item.Description, searchText)
                    || textContains(item.StorageLocation, searchText)
                    || textContains(item.PlaceFound, searchText)
                ) : true;
            return isMatch;
        }
    }
})();
